<template>
  <div
    class="hello"
    data-cy="hello-page"
  >
    <logo class="hello__logo" />
    <div class="about">
      <p class="about__text">
        <template v-if="$flavor.showEHB">
          {{ $flavor.textAppName }} ist ein Angebot des hep Verlags in Zusammenarbeit mit der Eidgenössischen Hochschule
          für Berufsbildung (EHB).
        </template>
        <template v-else> {{ $flavor.textAppName }} ist ein Angebot des hep Verlags. </template>
      </p>
    </div>
    <div class="hello__actions">
      <div class="hello__action">
        <h2 class="hello__action-title">Anmelden</h2>
        <p class="hello__action-text">
          Haben Sie schon ein Konto?<br />
          Melden Sie sich jetzt an.
        </p>
        <a
          class="button button--primary button--big hello__action-button actions__submit"
          href="/api/oauth/login/"
          data-cy="oauth-login"
          >Anmelden</a
        >
      </div>
      <div class="hello__action">
        <h2 class="hello__action-title">Registrieren</h2>
        <p class="hello__action-text">
          Sind sie neu bei {{ $flavor.textAppName }}? <br />
          Registrieren Sie jetzt ein neues Konto.
        </p>
        <a
          class="button button--primary button--big hello__action-button actions__submit"
          href="/api/oauth/register/"
          data-cy="oauth-register"
          >Registrieren</a
        >
      </div>
    </div>
    <div class="hello__information">
      <p>Brauchen Sie Unterstützung?</p>
      <a
        class="hep-link"
        :href="`https://${$flavor.baseUrl}/anleitung`"
        >Anleitung anschauen</a
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
const Logo = defineAsyncComponent(() => import('@/components/icons/Logo.vue'));
</script>

<style lang="postcss" scoped>
@import 'styles/css/mixins/shadow.css';
@import 'styles/css/mixins/typography.css';

.hello {
  max-width: var(--default-desktop-width);
  margin: 0 auto;

  &__logo {
    height: 32px;
  }

  &__actions {
    display: grid;
    gap: var(--large-spacing);
    grid-template-columns: 1fr 1fr;
    margin-bottom: var(--section-spacing);
  }

  &__action {
    display: flex;
    flex-direction: column;
    gap: var(--medium-spacing);

    @add-mixin widget-shadow;
    padding: var(--large-spacing);
  }

  &__action-title {
    font-size: var(--larger-font-size);
    font-weight: var(--semibold-font-weight);
    margin-bottom: 0;
  }

  &__action-text {
    @add-mixin regular-text;
  }

  &__action-button {
    align-self: flex-start;
    justify-self: flex-end;
    margin-top: auto;
  }

  &__information {
    display: flex;
    flex-direction: column;
    gap: var(--small-spacing);

    > p,
    a {
      @add-mixin regular-text;
    }
  }
}
</style>

<style scoped lang="scss">
@import 'styles/helpers';

$hello-block-margin: 2 * $medium-spacing;

.about {
  display: none;
  margin-bottom: $hello-block-margin;

  @include desktop {
    display: block;
  }

  &__text {
    margin-top: $medium-spacing;
    @include regular-text;
  }

  &__logos {
    & a:first-child {
      margin-right: $large-spacing;
    }
  }
}

.logos {
  &__logo {
    height: 30px;
  }
}

.links {
  margin-top: $hello-block-margin;
  display: flex;

  &__list-item {
    color: $color-silver-dark;

    > a {
      @include regular-text;
    }

    flex-direction: column;
    margin-top: $medium-spacing;

    &:first-child {
      margin-top: 0;
    }

    @include desktop {
      display: inline-block;
      flex-direction: row;

      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
  }
}
</style>
